import { render, staticRenderFns } from "./indexIntegrate.vue?vue&type=template&id=2336d262&scoped=true&"
import script from "./indexIntegrate.vue?vue&type=script&lang=js&"
export * from "./indexIntegrate.vue?vue&type=script&lang=js&"
import style0 from "./indexIntegrate.vue?vue&type=style&index=0&id=2336d262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336d262",
  null
  
)

export default component.exports